import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import SectionTabs, { SectionTab } from '../../components/admin/SectionTabs';

/** The staff area's sections. Each has its own row of sub-tabs inside. */
export const ADMIN_SECTIONS: SectionTab[] = [
  { value: 'jobs', label: 'Jobs' },
  { value: 'costs', label: 'Costs' },
  { value: 'keys', label: 'Keys' },
  { value: 'prompts', label: 'Prompts' },
  { value: 'plans', label: 'Plans' },
];

/**
 * The staff area: one row of tabs for its sections, and under it whichever
 * section the address names (`/admin/jobs/boards`, `/admin/costs/aws`, ...).
 */
const AdminPage: React.FC = () => {
  const location = useLocation();
  const section = location.pathname.split('/').filter(Boolean)[1] ?? ADMIN_SECTIONS[0].value;

  return (
    <Container maxWidth="xl" component="main" sx={{ py: { xs: 2, md: 3 } }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 700 }}>
          Admin
        </Typography>
        <Typography variant="body2" color="text.secondary">
          How JobFlo is running: the job board's sources, what the service costs, the keys it uses and the instructions its models follow.
        </Typography>
      </Box>
      <SectionTabs label="Admin sections" tabs={ADMIN_SECTIONS} value={section} to={(value) => `/admin/${value}`} />
      <Outlet />
    </Container>
  );
};

export default AdminPage;
